<template>
    <div class='sw-grid-flex sw-grid-flex--dir-column' :class="!materialId ? 'sw-dms--color-grey-64' : ''">
        <table>
            <thead>
            <tr>
                <th>Description</th>
                <th>Country</th>
                <th>Tariff Code</th>
                <th>&nbsp;</th>
            </tr>
            </thead>
            <tr v-if="!tariffCodes.length">
                <td colspan="4">No tariff codes were found.</td>
            </tr>
            <tr v-else v-for="(tariffCode, index) in materialTariffCodes"
                :key="'tariff-code-' + tariffCode.id"
                :class="index % 2 ? 'even': 'odd'">
                <td>{{ tariffCode.description }}</td>
                <td>{{ tariffCode.countryName }}</td>
                <td>{{ tariffCode.tariffCode }}</td>
                <td><a v-on:click="deleteTariffCode(tariffCode.id)">Remove</a></td>
            </tr>
        </table>
        <br>
        <table v-if="materialId">
            <thead>
            <tr>
                <th colspan="2">Add Tariff Code</th>
            </tr>
            </thead>
            <tr>
                <td>Description</td>
                <td><input type="text" name="description" id="description" v-model.trim="description"></td>
            </tr>
            <tr>
                <td>Country</td>
                <td>
                    <select name="country" id="country" v-model="country">
                        <option value=""></option>
                        <option value="224">United States</option>
                        <option value="148">Netherlands</option>
                    </select>
                </td>
            </tr>
            <tr>
                <td>Tariff Code</td>
                <td><input type="text" name="tariff-code" id="tariff-code" v-model.trim="tariffCode"></td>
            </tr>
            <tr>
                <td colspan="2">
                    <button :class="!materialId ? 'disabled-button' : 'action-button'" v-on:click="addTariffCode">Add
                    </button>
                </td>
            </tr>
        </table>
    </div>

</template>

<script>

import VueJQueryMixin from 'js/lib/vue/mixins/vue-jquery-mixin';
import VueSwMixin from 'js/lib/vue/mixins/vue-sw-mixin';
import BottomBanner from "rrViewComponents/Inshape/Admin/Materials/AddMaterial/BottomBannerComponent/bottom-banner";
import _ from 'underscore';

export default {
    name: "tariff-code",
    components: {BottomBanner},
    mixins: [VueSwMixin, VueJQueryMixin],
    props: {
        materialId: {
            type: Number,
            required: false
        },
        tariffCodes: {
            type: Array,
            required: true
        },
        currentMaterial: {
            type: Object,
            default: () => ({})
        }
    },
    created() {
        this.materialTariffCodes = this.tariffCodes;
    },
    data: () => ({
        description: "",
        country: "",
        tariffCode: "",
        materialTariffCodes: []
    }),
    methods: {
        addTariffCode() {
            let _this = this;
            let _data = {description: _this.description, country: _this.country, tariffCode: _this.tariffCode};
            let _countryName = this.$jQuery('select[id="country"] option:selected').text();
            this.$jQuery.ajax({
                type: 'POST',
                url: '/admin/material/' + _this.materialId + '/tariff-code',
                dataType: 'json',
                data: _data,
                success: (data) => {
                    _this.$emit('success', data);
                    this.$sw.notifications.success('Saved!');
                    _this.materialTariffCodes.unshift(
                        {
                            "countryId": _data.country,
                            "countryName": _countryName,
                            "description": _data.description,
                            "id": data.tariffCodeId,
                            "materialId": _data.materialId,
                            "tariffCode": _data.tariffCode
                        }
                    );
                    _this.description = "";
                    _this.country = "";
                    _this.tariffCode = "";
                },
                error: (jqXHR) => {
                    const response = JSON.parse(jqXHR.responseText);
                    _this.errorMessage = response.message;
                    _this.$emit('error', jqXHR);
                }
            });
        },
        deleteTariffCode(id) {
            let _this = this;
            let agree = confirm('Are you sure you want to delete tariff code?');
            let notifications = this.$sw.notifications;
            if (agree) {
                this.$jQuery.ajax({
                    type: 'DELETE',
                    url: '/admin/material/' + _this.materialId + '/tariff-code/',
                    dataType: 'json',
                    data: {'materialId': _this.materialId, 'tariffCodeId': id},
                    success: function (data) {
                        _this.materialTariffCodes = _this.materialTariffCodes.filter(materialTariffCodes => materialTariffCodes.id != id);
                        _this.$emit('success', data);
                        notifications.success('Deleted!');
                    },
                    error: (jqXHR) => {
                        const response = JSON.parse(jqXHR.responseText);
                        _this.errorMessage = response.message;
                        _this.$emit('error', jqXHR);
                    }
                });
            }
        }
    }
}
</script>
